import { render, staticRenderFns } from "./coderInpatientPxs.vue?vue&type=template&id=10e07b44&scoped=true&"
import script from "./coderInpatientPxs.vue?vue&type=script&lang=js&"
export * from "./coderInpatientPxs.vue?vue&type=script&lang=js&"
import style0 from "./coderInpatientPxs.vue?vue&type=style&index=0&id=10e07b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e07b44",
  null
  
)

export default component.exports